<div class="">
  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
    <h5 class="mb-0">{{ "heading-title.cart-details" | translate }}</h5>
  </div>
  <div class="column-padding py-3 cart-list-scroll">
    @for (product of bookingDetails?.cart?.products; track $index) {
    <div class="d-flex mb-3">
      <div class="flex-shrink-0">
        <img
          [src]="product.imageUrl ? helper.imageUrl + product.imageUrl : helper.DefaultImages.DefaultUserImage"
          (error)="handleProductImageError($event, product.imageUrl)"
          alt=""
          class="avatar-xl rounded material-shadow border"
        />
      </div>
      <div class="flex-grow-1 ms-3">
        <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
          <h6 class="fs-14 mb-0">{{ product.name }} ({{ product.qty }})</h6>
          <div class="mb-2">
            <span class="d-flex currency-gap">
              {{ product.price?.toFixed(decimalPointValue) }}
              <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                {{ bookingDetails.bookingInvoice?.currencySign }}
              </span>
            </span>
          </div>
        </div>
        <div class="mb-2">
          <span>
            {{ getVarientName(product.unit) }}
          </span>
          @if (product.weight > 0) { | {{ product.weight }} {{ product.weightUnit }} }
        </div>
        <div class="d-flex flex-wrap gap-1">
          @for(discount of product.discounts; track $index){
          <div class="offer-badge d-flex align-items-center gap-1">
            @if(discount.discountTag){
            {{ discount.discountTag | translate }}
            } @else {
            {{ "label-title.off-qd" | translate : { _VALUE: helper.roundUpValue(discount.discountPercentage) } }}
            }
            <span class="offer-description"
              >{{ "label-title.customer-saved" | translate : { _CURRENCY_SIGN: helper.currencySign } }}{{ discount.discount.toFixed(decimalPointValue) }}</span
            >
          </div>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
